module.exports = __webpack_public_path__ + "img/apollo-map.119dfccd.jpg";